export default {
    computed: {
        isAuthenticated() {
            return this.$store.getters.isLoggedIn;
        },
        isAdmin() {
            return this.$store.getters.isLoggedIn && this.$store.getters.isAdmin;
        },
        isDirector() {
            return this.$store.getters.isLoggedIn && this.$store.getters.isDirector;
        },
        isInternal() {
            return this.$store.getters.isLoggedIn && this.$store.getters.isInternal;
        },
        getUser: function () {
            return this.$store.getters.user;
        },
        getFieldsChangedColor: function () {
            return this.$store.getters.getFieldsChangedColor;
        }
    },
}